import connect from './connect';

export { AnalyticsScreen } from './AnalyticsScreen';

export default connect;
